<template>
  <div class="">
    <img class="calImg" src="../../../assets/calender2.png" alt="LiveRun">
    <div  class="month-year-select">
     
      <vue-monthly-picker
        v-model="selectedMonth"
        :selectedBackgroundColor="selectedBackgroundColor"
        :monthLabels="locale"
        :dateFormat='dateFormat'
        @selected="handleSelect"
        placeHolder='All Time'
      >
      </vue-monthly-picker>
    </div>
    <div style="float: right;cursor: pointer;" @click="showAddLuckyModal">
      <img   src="../../../assets/add-race.png"/>
      <div style="float: right;margin-left: 5px;margin-top: 6px;">Add Manually</div>
    </div>


    <div class="lucky-liverunner">
      <v-table         
        is-horizontal-resize        
        style="width:100%;font-size:11px"
        :is-loading="loading"
        :columns="columns"
        :table-data="tableData"
        :paging-index="(pageIndex-1)*pageSize"
        @on-custom-comp="customCompFunc">
      </v-table>

      <div class="mt20 mb20 bold" style="padding-top:25px">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :pageIndex ="pageIndex+1" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>

      <edit-lucky-live-runner :runnerData = "runnerData" :show="showEditModal" @saved="onSaved"  @closed="onClosed"></edit-lucky-live-runner> 
      
      <add-lucky-live-runner :show="showAddModal" @saved="onSaved"  @closed="onClosed"></add-lucky-live-runner> 
    
    </div>
  </div>
</template>

<script>
let dialogOptions = {
    html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
    loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
    reverse: false, // switch the button positions (left to right, and vise versa)
    cancelText: 'No',
    okText: 'Yes',
    animation: 'zoom', // Available: "zoom", "bounce", "fade"
    type: 'basic', // coming soon: 'soft', 'hard'
    verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
    clicksCount: 3,
    animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
  }
import Vue from "vue"
import Paginate from 'vuejs-paginate'
import Responsive from '@/components/Responsive'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import {sort, sortBy, prop,descend} from 'ramda'
import LuckyLiveRunnerService from "../../../services/luckyLiveRunner"
import EditLuckyLiveRunner from './EditLuckyLiveRunner'
import AddLuckyLiveRunner from './AddLuckyLiveRunner'
import VueMonthlyPicker from 'vue-monthly-picker'
//import moment from 'moment-timezone'
import moment from 'moment'
export default {
  name: 'LuckyLiveRunners',
  computed: {
    ...mapGetters({
      // runners: 'runners/allRunners',
      // totalPages: 'runners/totalPages'
    }),
  },
  data: () => ({
  columns: [
           {field: "raceDate", title:'Date', width: 80, titleAlign: 'center',columnAlign:'center',
              componentName:'date-time',
            },
            {field: "raceTime", title:'Run Start', width: 70, titleAlign: 'center',columnAlign:'center',
              componentName:'date-time',
            },
            // {field: "raceDate", title:'Date', width: 80, titleAlign: 'center',columnAlign:'center',isResize:true},
            // {field: "raceTime", title:'Run Start', width: 70, titleAlign: 'center',columnAlign:'center',isResize:true},
            // {field: "runDate", title:'Date', width: 80, titleAlign: 'center',columnAlign:'center'},
            // {field: "runStartTime", title:'Run Start', width: 70, titleAlign: 'center',columnAlign:'center'},
            {field: "runName", title:'Run Name', width: 230, titleAlign: 'center',columnAlign:'center',
              formatter: function (rowData,rowIndex,pagingIndex,field) {
                return '<a class="race_name" href="#/admin/past-run/detail/'+rowData.raceId+'" target="_blank"><div>'+rowData.runName+'</div></a>'
              }
            },
            {field: "trainerName", title:'Trainer', width: 100, titleAlign: 'center',columnAlign:'center'},
            {field: "runnerId", title:'Runner Id', width: 60, titleAlign: 'center',columnAlign:'center',componentName:'runner-id-link'},
            {field: "runnerName", title:'LiveRunner', width: 100, titleAlign: 'center',columnAlign:'center',isResize:true},
            {field: "presentSentDate", title:'Sent', width: 80, titleAlign: 'center',columnAlign:'center'},
            {field: "presentContent", title:'What', width: 170, titleAlign: 'center',columnAlign:'center'},
            {field: "note", title:'Note', width: 250, titleAlign: 'center',columnAlign:'center'}, 
            {field: 'custome-adv',width: 80, title: '', titleAlign: 'center',columnAlign:'center',
                componentName:'edit'}           
          ],
  tableData:[],
  pageIndex:0,
  pageTotal:null,
  pageSize:10,  
  startDate:moment().startOf('month').toISOString(),
  endDate:moment().endOf('month').toISOString(),
  showEditModal:false,  
  runnerData:{},
  selectedMonth: moment(),
  selectedBackgroundColor: '#423799',  
  locale: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],  
  dateFormat:"MMMM , YYYY",
  showAddModal:false,
  loading:false
  }),
  methods: {
    getAllLuckyRunners(startDate,endDate,page,size){
      this.loading=true
      LuckyLiveRunnerService.getLuckyLiveRunners(startDate,endDate,page,size).then(response => {         
        this.tableData=response.data.content
        this.pageTotal = response.data.totalElements
        this.loading=false
      }).catch(error => {
        this.loading=false
        console.log("err--->>",error)})
    },
    customCompFunc(params){ 
      //console.log("param---",params)
      if(params.columeName == 'delete'){
        this.$dialog.confirm("Are you sure you want to delete？", dialogOptions)
          .then((dialog) => {
            LuckyLiveRunnerService.deleteLuckyLiveRunner(params.rowData.id).then(response => {
            this.$delete(this.tableData,params.index)
            }).catch(error => {
                console.log("err--->",error) 
              }) 
          })
      }else{
        this.showEditModal = true
        this.runnerData = params
      }
      
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getAllLuckyRunners(this.startDate,this.endDate,this.pageIndex,this.pageSize)        
    },
    pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getAllLuckyRunners(this.startDate,this.endDate,this.pageIndex, this.pageSize)        
    },
    onSaved(data){
      this.showEditModal = false
      this.showAddModal=false
      this.getAllLuckyRunners(this.startDate,this.endDate,this.pageIndex, this.pageSize)  
    },
    onClosed(){
      this.showEditModal = false
      this.showAddModal=false
    },
    showAddLuckyModal(){
      this.showAddModal=true
    },
    handleSelect (value) {
      this.pageIndex = 0
      //show result for selected month
      if(value!=null){       
        var monthYear = moment([value.year(), value.month()])
        this.startDate= moment(monthYear).startOf('month').toISOString()
        this.endDate =  moment(monthYear).endOf('month').toISOString()  
      }else{ 
        //if no month year selected then show all        
        this.startDate= ''
        this.endDate =  ''
      }
      this.getAllLuckyRunners(this.startDate,this.endDate,this.pageIndex, this.pageSize) 
    },
    
  },
  created() { 
    //show result for current month
    this.getAllLuckyRunners(this.startDate,this.endDate,this.pageIndex, this.pageSize)
  },
  mounted () {
    
  },
  components: {
    Paginate,
    Responsive,
    EditLuckyLiveRunner,
    VueMonthlyPicker,
    AddLuckyLiveRunner
  }
}
Vue.component('date-time',{
        template:` <div>
                       <span v-if="field == 'raceDate'">{{newdate}}</span>
                       <span  v-if="field == 'raceTime'">{{newTime}}</span>
                    </div>
                   `,
        mounted () {
          //this.initdata()
        },
        data: () => ({
          newdate: '',
          newTime:''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
            
        },
        methods:{
          initdata(){
            var utcDate = this.rowData.raceDateTime
            this.newdate= moment(utcDate).format('YYYY-MM-DD')
            this.newTime= moment(utcDate).format('HH:mm:ss')
          },     
          
        },
        created () {
          this.initdata()
        },
        watch: {
          rowData: function (val) {
            this.initdata()
          },
      }
    })

Vue.component('edit',{
        template:` <div class="edit_operation">
                        <button id="editBtn" @click.stop.prevent="edit()"></button>
                        <!--<button id="deleteBtn" @click.stop.prevent="deleteRunner()"></button> -->
                         <button id="deleteBtn" @click.stop.prevent="deleteRunner()"></button> 
                    </div>
                   `,
        data: () => ({
          path: ''
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          edit(){
            let params = {columeName:"edit",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          deleteRunner(){
            let params = {columeName:"delete",rowData:this.rowData,index:this.index}
            this.$emit('on-custom-comp',params)
          },
          
        },
        created () {
        },
    })

  Vue.component('runner-id-link',{
        template:`<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.runnerId}}</a>&nbsp
        </span>`,
        data: () => ({
        //   id:null 
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          runnerData(){
              let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: this.rowData.runnerId
                        }
                    })
              window.open(route.href, '_blank')
          }
        },
        created() { 
        }
})
</script>

<style>

 .lucky-liverunner tr.v-table-header-row {
    background: #423799;
    color: white;
    font-size: 12px;
    font-weight: bold;
}
#editBtn {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  /* margin-right: 10px; */
  background-image: url(../../../assets/edit.png);
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
}
#deleteBtn {
  width: 22px;
  height: 22px;
  margin-top: 0px;
  background-image: url(../../../assets/delete.png);
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
}
.month-year-select{
  margin-bottom:30px;
  width: 20%;
  float: left;
}
.month-year-select .active{
  background: transparent
}

.month-year-select .month-year-display.input {
    /* border: none;
    box-shadow: none;
    border-bottom: 1px solid darkgray;
    border-radius: 0; */
}
.calImg{
  float: left;
  /* margin-top: 4px; */
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// AllLuckyLiveRunners.vue?1ccdeb19